import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucQuyTrinhSanXuatPhanLoai } from 'src/app/shared/DanhMucQuyTrinhSanXuatPhanLoai.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucQuyTrinhSanXuatPhanLoaiService extends BaseService{

    displayColumns001: string[] = ['STT', 'ID', 'Name', 'SortOrder', 'Save'];
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "DanhMucQuyTrinhSanXuatPhanLoai";
    }
}

